module.exports = __webpack_public_path__ + "static/media/brawl_stars_bear.a58cde33.png";